module.exports = __webpack_public_path__ + "img/e0c58e0.png";